var React = require('react');

function UniplacesIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#00adef","d":"M37.9 1.1L2.3 0C.9 0-.2 1.1 0 2.6l6 44.1c.2 1.5 1.3 1.9 2.5 1.1l4.8-3.4c1.2-.8 2.9-1.5 4.8-1.4s16.5 1.1 16.5 1.1c1.5.1 2.7-1 2.9-2.5l2.8-37.7c.2-1.5-.9-2.7-2.4-2.8zm-.7 4.2L35 40.2c0 .6-.5 1-1.1.8l-11.3-2.4c-1.6-.3-2.7-1.2-2.9-2.8L16.8 9.7c-.1-.6.4-1.2.9-1.3l18.4-3.9c.7-.1 1.1.2 1.1.8z"}));
}

UniplacesIcon.defaultProps = {"width":"44","height":"48","viewBox":"0 0 44 48"};

module.exports = UniplacesIcon;

UniplacesIcon.default = UniplacesIcon;
